<script setup lang="ts">
import { CheckIcon } from "@heroicons/vue/20/solid";
import { Checkbox } from "radix-vue/namespaced";
import { twMerge } from "tailwind-merge";
import { useField } from "vee-validate";

import { useUser } from "@/composables/api/useUser";

const props = defineProps<{
  name: string;
  value: string;
}>();

const { data: user } = useUser();

const { checked, handleChange } = useField(props.name, undefined, {
  type: "checkbox",
  checkedValue: props.value,
});
</script>

<template>
  <Checkbox.Root
    :class="
      twMerge(
        'border-galbani text-galbani flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white',
        user?.current_mechanic === 'lactel' && 'text-lactel-blue border-lactel-blue',
      )
    "
    @update:checked="handleChange"
  >
    <Transition name="fade">
      <Checkbox.Indicator v-if="checked">
        <CheckIcon class="size-4" />
      </Checkbox.Indicator>
    </Transition>
  </Checkbox.Root>
</template>

<style lang="css" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
